import { render, staticRenderFns } from "./CentroVacinacaoComponente.vue?vue&type=template&id=356c71c7&scoped=true"
import script from "./CentroVacinacaoComponente.vue?vue&type=script&lang=js"
export * from "./CentroVacinacaoComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroVacinacaoComponente.vue?vue&type=style&index=0&id=356c71c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356c71c7",
  null
  
)

export default component.exports